// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"815":"2bed3408","956":"31d6cfe0"}[chunkId] + ".chunk.css";
};